document.addEventListener("DOMContentLoaded", () => {

    const dropdownYear = document.querySelectorAll('.dropdownYear');
    if (!dropdownYear.length) {
        return
    }
    console.log(dropdownYear);

    dropdownYear.forEach(item => {
        item.addEventListener('change', () => {
            var selectedYear = item.value;

            var url = new URL(window.location.href);

            if(url.searchParams.has('page')) {
                url.searchParams.delete('page');
            }

            // Update the 'year' query parameter

            if(selectedYear == "All Years") {
                url.searchParams.delete('year');
            } else {
                url.searchParams.set('year', selectedYear);
            }

            // Redirect to the new URL with the updated query string
            window.location.href = url.toString();
        });
    });

});


